import React from 'react';
import Modal from 'react-bootstrap/Modal';

import { Dropdown } from 'primereact/dropdown';

import './Style.css';

class ModalAcoesGrupo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            form: {
                acao: '',
                user: null,
                period: '',
                password: '',
            },
        };
    }

    handleActionChange = (event) => {
        this.setState({
            form: {
                ...this.state.form,
                acao: event.value,
                user: null,
                period: '',
                password: '',
            },
        });
    };

    handleInputChange = (event) => {
        const {
            name,
            value,
        } = event.target;

        this.setState({
            form: {
                ...this.state.form,
                [name]: value,
            },
        });
    };

    handleUserChange = (event) => {
        this.setState({
            form: {
                ...this.state.form,
                user: event.value,
            },
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        const {
            form,
        } = this.state;

        if (!form.acao) {
            alert('Selecione uma ação.');
            return;
        }

        await this.props.onSubmit(form);
    };

    handleClose = () => {
        if (this.props.loading) {
            return;
        }

        this.setState({
            form: {
                acao: '',
                user: null,
                period: '',
                password: '',
            },
        });

        this.props.onClose();
    };

    render() {
        const {
            open,
            loading,
            selectedBases,
            acoes,
            operadores,
        } = this.props;

        const {
            form,
        } = this.state;

        if (!open) {
            return null;
        }

        const mostrarUsuario = form.acao === 'Transferir Ligações para outro usuário';
        const mostrarPeriodo = form.acao === 'Adicionar Bases em Outro Período';
        const mostrarSenha = form.acao === 'Deletar Bases';

        return (
            <div style={{ zIndex: '9999' }}>
                <Modal
                    show={open}
                    onHide={this.handleClose}
                    dialogClassName="modal-acoes-grupo"
                    size="md"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Ações em Grupo
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <form
                            className="form-modal"
                            onSubmit={this.handleSubmit}
                        >
                            <div className="formulario">

                                <div className="form-group">
                                    <label>Empreendimentos selecionados: {selectedBases?.length || 0}</label>
                                </div>

                                <div className="form-group">
                                    <label>Ação</label>

                                    <Dropdown
                                        value={form.acao}
                                        options={acoes || []}
                                        placeholder="Selecione"
                                        showClear
                                        className="dropdown"
                                        optionLabel="label"
                                        optionValue="value"
                                        onChange={
                                            this.handleActionChange
                                        }
                                        disabled={loading}
                                    />
                                </div>

                                {mostrarUsuario && (
                                    <div className="form-group">
                                        <label>Operador</label>

                                        <Dropdown
                                            value={form.user}
                                            options={operadores || []}
                                            placeholder="Selecione"
                                            showClear
                                            filter
                                            className="dropdown"
                                            optionLabel="name"
                                            optionValue="id"
                                            onChange={
                                                this.handleUserChange
                                            }
                                            disabled={loading}
                                        />
                                    </div>
                                )}

                                {mostrarPeriodo && (
                                    <div className="form-group">
                                        <label>Período</label>

                                        <input
                                            type="date"
                                            name="period"
                                            value={form.period}
                                            onChange={
                                                this.handleInputChange
                                            }
                                            className="form-control campo"
                                            disabled={loading}
                                        />
                                    </div>
                                )}

                                {mostrarSenha && (
                                    <div className="form-group">
                                        <label>Senha</label>

                                        <input
                                            type="password"
                                            name="password"
                                            value={form.password}
                                            onChange={
                                                this.handleInputChange
                                            }
                                            className="form-control campo"
                                            placeholder="Digite"
                                            disabled={loading}
                                        />
                                    </div>
                                )}

                                <div className="form-buttons-acoes">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-round"
                                        onClick={this.handleClose}
                                        disabled={loading}
                                    >
                                        Cancelar
                                    </button>

                                    <button
                                        type="submit"
                                        className="btn btn-success btn-round background-brain"
                                        disabled={loading}
                                        style={{ position: 'absolute', right: 0 }}
                                    >
                                        {loading ? (
                                            <>
                                                <i className="fa fa-spinner fa-spin"></i>{' '}
                                                Processando...
                                            </>
                                        ) : (
                                            'Executar'
                                        )}
                                    </button>

                                </div>

                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalAcoesGrupo;